import { Box } from "@mui/material";
import { useState } from "react";
import { getAgentIcon } from "./agentIcons";

interface Props {
  slug: string;
  size: number;
}

const AgentIcon = ({ slug, size }: Props) => {
  const [today] = useState(() => new Date());
  const icon = getAgentIcon(slug, today);
  if (!icon) {
    return null;
  }

  return (
    <Box
      component="img"
      src={icon.src}
      alt=""
      sx={{ width: size, height: size, flexShrink: 0, imageRendering: icon.pixelated ? "pixelated" : "auto" }}
    />
  );
};

export default AgentIcon;
